import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieBanner from "../CookieBanner";
import PixelInjector from "../PixelInjector";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-oc-primary">
      <Navbar />
      <main className="flex-1 pt-[72px] sm:pt-[104px]">{children}</main>
      <Footer />
      <CookieBanner />
      <PixelInjector />
    </div>
  );
}
